import { Component } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { saveAs } from 'file-saver';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { GridService } from 'app/shared/services/grid.service';
import { QualityService } from 'app/shared/services/quality.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';
import { UserService } from 'app/shared/services/user.service';

@AutoUnsubscribe()
@Component({
  selector: 'quality-and-viewability-component',
  templateUrl: './quality-and-viewability.component.html',
  styleUrls: ['./quality-and-viewability.component.scss'],
})
export class QualityAndViewabilityComponent {
  public queryParams: any;
  public data: Array<any>;
  public dataTotal: any;
  public dataBySupply: any;
  public dataByDemand: any;
  public dataBySupplyByDomain: any;
  public dataBySupplyTotal: any;
  public dataByDemandTotal: any;
  public dataBySupplyByDomainTotal: any;
  public columnsSettings: Array<any>;
  public columnsDemandMoat: Array<any>;
  public columnsSupplyMoat: Array<any>;
  public columnsSettingsSupplyByDomains: Array<any>;
  public reportParams: any;
  public startDate: Date;
  public endDate: Date;
  public tabsData: Array<any>;
  public selectedTab: number;
  public isLoading: boolean;
  public isError: boolean;
  public isExporting: boolean;
  public currPluginPartner: number;
  public loadedReports: Array<any>;
  public currPage: number;
  public filters: any;
  public sorting: any;
  public itemsPerPage: number;
  public numOfPages: number;
  public totalAmount: number;
  public linkColumns: Array<string>;
  public currSubscription: any;
  public currTotalsSubscription: any;
  public subscriptions: Array<any>;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public httpService: HttpService,
    public gridService: GridService,
    public qualityService: QualityService,
    public dictionaryService: DictionaryService,
    public userService: UserService,
    public ga: GoogleAnalyticsService
  ) {
    this.data = [];
    this.dataTotal = {};
    this.dataBySupply = [];
    this.dataByDemand = [];
    this.dataBySupplyTotal = [];
    this.dataByDemandTotal = [];
    this.dataBySupplyByDomain = [];
    this.dataBySupplyByDomainTotal = [];
    this.columnsSettings = [];
    this.columnsSupplyMoat = [
      { key: 'playerId', label: 'SUPPLY_ID', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'SUPPLY_NAME', filterType: 'INPUT', width: 200 },
      { key: 'player_type', label: 'SUPPLY_TYPE', filterType: 'SELECT' },
      {
        key: 'environment',
        label: 'ENVIRONMENT',
        parseFunction: this.gridService.parseMultipleEnvironments,
        parseTooltipFunction: this.gridService.parseMultipleEnvironmentsTooltip,
      },
      {
        key: 'opportunities',
        label: 'OPPORTUNITIES',
        tooltipKey: 'OPPORTUNITIES_TT',
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        defaultVisibility: false,
        measureFilter: true,
        filterType: 'RANGE',
      },
      {
        key: 'adStarts',
        label: 'IMPRESSIONS',
        tooltipKey: 'REPORT_TOOLTIP_I',
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'revenue',
        label: 'REVENUE',
        tooltipKey: 'REPORT_TOOLTIP_R',
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        defaultVisibility: false,
        measureFilter: true,
        filterType: 'RANGE',
        char: '$',
        align: 'left',
      },
      {
        key: 'total',
        tooltipKey: 'SAMPLED_IMPRESSIONS_TT',
        label: 'SAMPLED_IMPRESSIONS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'ivt_measurable',
        tooltipKey: 'IVT_MEASURABLE',
        label: 'IVT_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_measurable_rate',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'ivt',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_rate',
        tooltipKey: 'IVT_PERCENTAGE_TT',
        label: 'IVT_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'data_center_traffic',
        label: 'DATA_CENTER_TRAFFIC',
        tooltipKey: 'DATA_CENTER_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'old_browser',
        label: 'OLD_BROWSER',
        tooltipKey: 'OLD_BROWSER',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'proxy_traffic',
        label: 'PROXY_TRAFFIC',
        tooltipKey: 'PROXY_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'viewability_analyzed',
        label: 'VIEWABILITY_ANALYZED',
        tooltipKey: 'VIEWABILITY_ANALYZED',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable',
        tooltipKey: 'VIEWABILITY_MEASURABLE',
        label: 'VIEWABILITY_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable_rate',
        tooltipKey: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        label: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
      {
        key: 'viewability',
        tooltipKey: 'VIEWABILITY',
        label: 'VIEWABILITY',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_rate',
        label: 'VIEWABILITY_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'hover',
        tooltipKey: 'HOVERS',
        label: 'HOVERS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'hover_percent',
        tooltipKey: 'HOVERS_PERCENT_TT',
        label: 'HOVERS_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
    ];

    this.columnsDemandMoat = [
      { key: 'vastId', label: 'DEMAND_ID', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'DEMAND_NAME', filterType: 'INPUT', width: 200 },
      { key: 'vast_type', label: 'DEMAND_TYPE', filterType: 'SELECT' },
      { key: 'url', label: 'DEMAND_URL', filterType: 'INPUT' },
      {
        key: 'environment',
        label: 'ENVIRONMENT',
        parseFunction: this.gridService.parseMultipleEnvironments,
        parseTooltipFunction: this.gridService.parseMultipleEnvironmentsTooltip,
      },
      {
        key: 'adStarts',
        label: 'IMPRESSIONS',
        tooltipKey: 'REPORT_TOOLTIP_I',
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'revenue',
        label: 'REVENUE',
        tooltipKey: 'REPORT_TOOLTIP_R',
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        defaultVisibility: false,
        measureFilter: true,
        filterType: 'RANGE',
        char: '$',
        align: 'left',
      },
      {
        key: 'total',
        tooltipKey: 'SAMPLED_IMPRESSIONS_TT',
        label: 'SAMPLED_IMPRESSIONS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'ivt_measurable',
        tooltipKey: 'IVT_MEASURABLE',
        label: 'IVT_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_measurable_rate',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'ivt',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_rate',
        tooltipKey: 'IVT_PERCENTAGE_TT',
        label: 'IVT_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'data_center_traffic',
        label: 'DATA_CENTER_TRAFFIC',
        tooltipKey: 'DATA_CENTER_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'old_browser',
        label: 'OLD_BROWSER',
        tooltipKey: 'OLD_BROWSER',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'proxy_traffic',
        label: 'PROXY_TRAFFIC',
        tooltipKey: 'PROXY_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'viewability_analyzed',
        label: 'VIEWABILITY_ANALYZED',
        tooltipKey: 'VIEWABILITY_ANALYZED',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable',
        tooltipKey: 'VIEWABILITY_MEASURABLE',
        label: 'VIEWABILITY_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable_rate',
        tooltipKey: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        label: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
      {
        key: 'viewability',
        tooltipKey: 'VIEWABILITY',
        label: 'VIEWABILITY',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_rate',
        label: 'VIEWABILITY_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'hover',
        tooltipKey: 'HOVERS',
        label: 'HOVERS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'hover_percent',
        tooltipKey: 'HOVERS_PERCENT_TT',
        label: 'HOVERS_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
    ];
    this.columnsSettingsSupplyByDomains = [
      { key: 'playerId', label: 'SUPPLY_ID', filterType: 'INPUT', primaryKey: true },
      { key: 'name', label: 'SUPPLY_NAME', filterType: 'INPUT', width: 200 },
      { key: 'player_type', label: 'SUPPLY_TYPE', filterType: 'SELECT' },
      {
        key: 'environment',
        label: 'ENVIRONMENT_SHORT',
        parseFunction: this.gridService.parseMultipleEnvironments,
        parseTooltipFunction: this.gridService.parseMultipleEnvironmentsTooltip,
      },
      { key: 'domain', label: 'DOMAIN', filterType: 'INPUT' },
      {
        key: 'opportunities',
        label: 'OPPORTUNITIES',
        tooltipKey: 'OPPORTUNITIES_TT',
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        defaultVisibility: false,
        measureFilter: true,
        filterType: 'RANGE',
      },
      {
        key: 'adStarts',
        label: 'IMPRESSIONS',
        tooltipKey: 'REPORT_TOOLTIP_I',
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'revenue',
        label: 'REVENUE',
        tooltipKey: 'REPORT_TOOLTIP_R',
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        defaultVisibility: false,
        measureFilter: true,
        filterType: 'RANGE',
        char: '$',
        align: 'left',
      },
      {
        key: 'total',
        tooltipKey: 'SAMPLED_IMPRESSIONS_TT',
        label: 'SAMPLED_IMPRESSIONS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
      },
      {
        key: 'ivt_measurable',
        tooltipKey: 'IVT_MEASURABLE',
        label: 'IVT_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_measurable_rate',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'ivt',
        tooltipKey: 'IVT_MEASURABLE_PERCENTAGE_TT',
        label: 'IVT',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'ivt_rate',
        tooltipKey: 'IVT_PERCENTAGE_TT',
        label: 'IVT_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'data_center_traffic',
        label: 'DATA_CENTER_TRAFFIC',
        tooltipKey: 'DATA_CENTER_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'old_browser',
        label: 'OLD_BROWSER',
        tooltipKey: 'OLD_BROWSER',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'proxy_traffic',
        label: 'PROXY_TRAFFIC',
        tooltipKey: 'PROXY_TRAFFIC',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'viewability_analyzed',
        label: 'VIEWABILITY_ANALYZED',
        tooltipKey: 'VIEWABILITY_ANALYZED',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable',
        tooltipKey: 'VIEWABILITY_MEASURABLE',
        label: 'VIEWABILITY_MEASURABLE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_measurable_rate',
        tooltipKey: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        label: 'VIEWABILITY_MEASURABLE_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
      {
        key: 'viewability',
        tooltipKey: 'VIEWABILITY',
        label: 'VIEWABILITY',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
      },
      {
        key: 'viewability_rate',
        label: 'VIEWABILITY_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        measureFilter: false,
      },
      {
        key: 'hover',
        tooltipKey: 'HOVERS',
        label: 'HOVERS',
        rightAligned: true,
        parseFunction: this.gridService.parseNumeric,
        parseTooltipFunction: this.gridService.parseNumeric,
        measureFilter: false,
        defaultVisibility: false,
      },
      {
        key: 'hover_percent',
        tooltipKey: 'HOVERS_PERCENT_TT',
        label: 'HOVERS_PERCENTAGE',
        rightAligned: true,
        parseFunction: this.gridService.parseNumericPadd,
        parseTooltipFunction: this.gridService.parseNumericPadd,
        measurement: { char: '%', align: 'right' },
        defaultVisibility: false,
        measureFilter: false,
      },
    ];
    this.currPluginPartner = this.qualityService.pluginPartners[0].id;
    this.setTabsData();
    this.isLoading = false;
    this.isError = false;
    this.isExporting = false;
    this.currPage = 1;
    this.filters = {};
    this.sorting = {};
    this.itemsPerPage = 50;
    this.totalAmount = 0;
    this.numOfPages = 0;
    this.linkColumns = [];
    this.initLoadedReportsData();
    this.subscriptions = [];
    this.subscriptions.push(
      this.route.queryParams.subscribe((queryParams: any) => {
        // Store the query params
        this.queryParams = _.cloneDeep(queryParams);
        // Parse the query parameters
        this.parseQueryParams();
      })
    );
  }

  ngOnDestroy() {}

  ngOnInit() {
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_CHANGE') {
          this.setTabsData();
          this.initLoadedReportsData();
          this.parseQueryParams();
        }
      })
    );
    this.sharedService.setPageTitle('QUALITY_AND_VIEWABILITY');
  }

  // Parse the query parameters
  parseQueryParams() {
    let queryParams: any;
    const dates: any = {};
    let startDateStr = '';
    let endDateStr = '';
    // Start and end date
    if (this.queryParams.sd && this.queryParams.ed) {
      startDateStr = this.queryParams.sd;
      endDateStr = this.queryParams.ed;
    } else if (!this.sharedService.isEmpty(localStorage.getItem('selectedDates'))) {
      const savedDates: any = JSON.parse(localStorage.getItem('selectedDates'));
      startDateStr = savedDates.startDate;
      endDateStr = savedDates.endDate;
    }

    this.startDate = this.sharedService.stringToESTDate(startDateStr);
    this.endDate = this.sharedService.stringToESTDate(endDateStr);
    dates.startDate = this.startDate;
    dates.endDate = this.endDate;
    localStorage.setItem('selectedDates', JSON.stringify(dates));

    // Plugin partner
    this.currPluginPartner = this.qualityService.pluginPartners[0].id;
    if (this.queryParams.partner) {
      if (!isNaN(Number(this.queryParams.partner))) {
        this.currPluginPartner = +this.queryParams.partner;
        if (!_.map(this.qualityService.pluginPartners, 'id').includes(this.currPluginPartner)) {
          this.currPluginPartner = this.qualityService.pluginPartners[0].id;
        }
      }
    }
    // Selected tab
    this.selectedTab = 0;
    if (this.queryParams.tab) {
      if (!isNaN(Number(this.queryParams.tab))) {
        this.selectedTab = +this.queryParams.tab;
        if (this.currPluginPartner === 4) {
          if (this.selectedTab !== 0 && this.selectedTab !== 1 && this.selectedTab !== 2) {
            this.selectedTab = 0;
          }
        }
      }
    }
    // Page
    if (this.queryParams.p) {
      this.currPage = !this.sharedService.isEmpty(this.queryParams.p) ? +this.queryParams.p : 1;
    } else {
      this.currPage = 1;
    }
    // Get report
    queryParams = {
      sd: moment(this.startDate).format('YYYY-MM-DD'),
      ed: moment(this.endDate).format('YYYY-MM-DD'),
      partner: this.currPluginPartner.toString(),
      tab: this.selectedTab.toString(),
      p: this.currPage.toString(),
    };
    if (!_.isEqual(queryParams, this.queryParams)) {
      this.router.navigate([], { queryParams: queryParams }).then(() => {
        return false;
      });
    } else {
      this.isLoading = true;
      this.reportParams = {
        startDate: moment(this.startDate).format('ddd MMM DD YYYY 00:00:00'),
        endDate: moment(this.endDate).format('ddd MMM DD YYYY 23:59:59'),
        quality_type: this.currPluginPartner,
        filters: this.parseFilters(),
        sorting: this.sorting,
        page: this.currPage,
        amountPerPage: this.itemsPerPage,
        is_desktop: 0,
        is_mobile_web: 0,
        is_mobile_app: 0,
      };
      if (this.sorting.attrName) {
        if (_.find(this.getColumnsSettings(), { key: this.sorting.attrName })) {
          this.reportParams.sorting = this.sorting;
        } else {
          this.sorting = {};
        }
      }
      this.onEnvironmentFilterChange();
      this.loadReport();
    }
    // Update
    this.updateLinkColumns();
  }

  // Get columns
  getColumnsSettings() {
    switch (this.selectedTab) {
      case 0:
        return this.getSupplyColumns();
      case 1:
        return this.getDemandColumns();
      case 2:
        return this.getSupplyDomainColumns();
      default:
        return [];
    }
  }

  // Get columns: supplies
  getSupplyColumns() {
    if (this.currPluginPartner == 4) {
      return this.columnsSupplyMoat;
    }
  }

  // Get columns: demands
  getDemandColumns() {
    if (this.currPluginPartner == 4) {
      return this.columnsDemandMoat;
    }
  }

  // Get columns: supply-by-domains
  getSupplyDomainColumns() {
    if (this.currPluginPartner == 4) {
      return this.columnsSettingsSupplyByDomains;
    }
  }

  // Update link columns
  updateLinkColumns() {
    if (this.currPluginPartner == 4) {
      switch (this.selectedTab) {
        case 0:
          this.linkColumns = ['playerId', 'name'];
          break;
        case 1:
          this.linkColumns = ['demandId', 'name'];
          break;
      }
    }
  }

  // Get the data for the grid-tabs
  setTabsData() {
    const tabsData: Array<any> = [
      { title: this.dictionaryService.get('SAMPLED_SUPPLY') },
      { title: this.dictionaryService.get('SAMPLED_DEMAND') },
    ];
    if (this.userService.getFeatureState('quality_report_all_player_by_domain')) {
      tabsData.push({ title: this.dictionaryService.get('ALL_SAMPLED_SUPPLY_BY_DOMAIN') });
    }
    this.tabsData = _.cloneDeep(tabsData);
    this.selectedTab = 0;
  }

  // Initialize loaded reports data
  initLoadedReportsData() {
    this.loadedReports = [];
    this.qualityService.pluginPartners.forEach((partner: any) => {
      this.loadedReports[partner.id] = [];
      this.tabsData.forEach((tab: any, tabIndex: number) => {
        this.loadedReports[partner.id][tabIndex] = {
          data: false,
          totals: false,
        };
      });
    });
  }

  // Initialize supply data
  initSupplyData() {
    this.currSubscription = this.httpService
      .post('quality_report/getQualityReportByPlayer', this.reportParams)
      .subscribe(
        (response: any) => {
          const data: Array<any> = response.data.data;
          this.totalAmount = +response.data.paginator.totalAmount;
          this.numOfPages = +response.data.paginator.totalAmountOfPages;
          for (let i = 0; i < data.length; i++) {
            data[i].environment = {
              is_desktop: data[i].is_desktop === '1',
              is_mobile_web: data[i].is_mobile_web === '1',
              is_mobile_app: data[i].is_mobile_app === '1',
            };
            data[i].$$link =
              '/quality/supply/' +
              data[i].playerId +
              '?sd=' +
              moment(this.startDate).format('YYYY-MM-DD').toString() +
              '&ed=' +
              moment(this.endDate).format('YYYY-MM-DD').toString();
          }
          this.dataBySupply = data;
          this.onReportLoaded(0, 'data');
        },
        () => {
          this.onError();
        }
      );

    this.currTotalsSubscription = this.httpService
      .post('report_totals/getQualityReportByPlayerTotals', this.reportParams)
      .subscribe(
        (response: any) => {
          this.dataBySupplyTotal = response.data[0];
          this.onReportLoaded(0, 'totals');
        },
        () => {
          this.onError();
        }
      );
    this.subscriptions.push(this.currSubscription);
    this.subscriptions.push(this.currTotalsSubscription);
  }

  // Initialize demand data
  initDemandData() {
    this.currSubscription = this.httpService.post('quality_report/getQualityReportByVast', this.reportParams).subscribe(
      (response: any) => {
        const data: Array<any> = response.data.data;
        this.totalAmount = +response.data.paginator.totalAmount;
        this.numOfPages = +response.data.paginator.totalAmountOfPages;
        for (let i = 0; i < data.length; i++) {
          data[i].environment = {
            is_desktop: data[i].is_desktop === '1',
            is_mobile_web: data[i].is_mobile_web === '1',
            is_mobile_app: data[i].is_mobile_app === '1',
          };
          data[i].$$link =
            '/quality/demand/' +
            data[i].vastId +
            '?sd=' +
            moment(this.startDate).format('YYYY-MM-DD').toString() +
            '&ed=' +
            moment(this.endDate).format('YYYY-MM-DD').toString();
        }
        this.dataByDemand = data;
        this.onReportLoaded(1, 'data');
      },
      () => {
        this.onError();
      }
    );

    this.currTotalsSubscription = this.httpService
      .post('report_totals/getQualityReportByVastTotals', this.reportParams)
      .subscribe(
        (response: any) => {
          this.dataByDemandTotal = response.data[0];
          this.onReportLoaded(1, 'totals');
        },
        () => {
          this.onError();
        }
      );
    this.subscriptions.push(this.currSubscription);
    this.subscriptions.push(this.currTotalsSubscription);
  }

  // Initialize supply-by-domain data
  initSupplyByDomainData() {
    this.currSubscription = this.httpService
      .post('quality_report/getQualityReportAllPlayerByDomain', this.reportParams)
      .subscribe(
        (response: any) => {
          const data: Array<any> = response.data ? response.data.data : [];
          this.totalAmount = +response.data.paginator.totalAmount;
          this.numOfPages = +response.data.paginator.totalAmountOfPages;
          for (let i = 0; i < data.length; i++) {
            data[i].environment = {
              is_desktop: data[i].is_desktop === '1',
              is_mobile_web: data[i].is_mobile_web === '1',
              is_mobile_app: data[i].is_mobile_app === '1',
            };
          }
          this.dataBySupplyByDomain = data;
          this.onReportLoaded(2, 'data');
        },
        () => {
          this.onError();
        }
      );

    this.currTotalsSubscription = this.httpService
      .post('report_totals/getQualityReportAllPlayerByDomainTotals', this.reportParams)
      .subscribe(
        (response: any) => {
          this.dataBySupplyByDomainTotal = response.data ? response.data[0] : [];
          this.onReportLoaded(2, 'totals');
        },
        () => {
          this.onError();
        }
      );
    this.subscriptions.push(this.currSubscription);
    this.subscriptions.push(this.currTotalsSubscription);
  }

  // Load report
  loadReport() {
    let currReportLoaded: any;

    if (this.tabsData && this.tabsData.length) {
      if (!this.tabsData[this.selectedTab]) {
        this.selectedTab = 0;
      }
    } else {
      this.onError();
    }
    currReportLoaded = this.loadedReports[this.currPluginPartner][this.selectedTab];

    if (!currReportLoaded || !currReportLoaded.data || !currReportLoaded.totals) {
      this.isLoading = true;
      this.sharedService.sendMessage('GRID_DETECT_CHANGES');
      if (this.currSubscription) {
        this.currSubscription.unsubscribe();
      }
      if (this.currTotalsSubscription) {
        this.currTotalsSubscription.unsubscribe();
      }
      switch (this.selectedTab) {
        case 0:
          this.initSupplyData();
          break;
        case 1:
          this.initDemandData();
          break;
        case 2:
          this.initSupplyByDomainData();
          break;
      }
    } else {
      this.onReportLoaded(this.selectedTab, 'data');
    }
  }

  onError() {
    this.isLoading = false;
    this.isError = true;
    this.currSubscription = null;
    this.currTotalsSubscription = null;
  }

  // Export all data
  exportAll() {
    let path = '';
    let reportParams: any;
    if (this.selectedTab === 0) {
      path = 'getQualityReportByPlayer';
    } else if (this.selectedTab === 1) {
      path = 'getQualityReportByVast';
    } else if (this.selectedTab === 2) {
      path = 'getQualityReportPlayerByDomain';
    } else {
      return;
    }
    this.isExporting = true;
    reportParams = _.cloneDeep(this.reportParams);
    delete reportParams.amountPerPage;
    this.subscriptions.push(
      this.httpService.post('reports_csv_export/' + path, reportParams).subscribe(
        (response: any) => {
          const blob = new Blob([response.data], { type: 'text/csv; charset=utf-8' });
          saveAs(blob, this.dictionaryService.get('EXPORTED_DATA') + '.csv');
          this.isExporting = false;
          this.sharedService.sendMessage('GRID_DETECT_CHANGES');
        },
        () => {
          this.isExporting = false;
          this.isError = true;
          this.sharedService.sendMessage('GRID_DETECT_CHANGES');
        }
      )
    );
  }

  // Parse filters
  parseFilters() {
    const filters: any = _.cloneDeep(this.filters);
    if (filters.player_type) {
      if (filters.player_type.length > 0) {
        filters.player_type = filters.player_type[0];
      }
    }
    if (filters.vast_type) {
      if (filters.vast_type.length > 0) {
        filters.vast_type = filters.vast_type[0];
      }
    }
    if (filters.revenue) {
      if (filters.revenue.hasOwnProperty('min') && filters.revenue.min !== null) {
        filters.revenue.min = parseFloat(filters.revenue.min.toString().replace(/[^0-9.]/g, ''));
      }
      if (filters.revenue.hasOwnProperty('max') && filters.revenue.max !== null) {
        filters.revenue.max = parseFloat(filters.revenue.max.toString().replace(/[^0-9.]/g, ''));
      }
    }
    delete filters.environment;
    return filters;
  }

  // On report loaded
  onReportLoaded(tab: number, type: string) {
    let currReportLoaded: any;
    let n: number;
    this.data = [];
    this.loadedReports[this.currPluginPartner][tab][type] = true;
    currReportLoaded = this.loadedReports[this.currPluginPartner][tab];
    if (currReportLoaded.data && currReportLoaded.totals) {
      // Dummy items for previous pages
      for (let i = 1; i < this.currPage; i++) {
        for (let j = 0; j < this.itemsPerPage; j++) {
          this.data.push({});
        }
      }
      switch (this.selectedTab) {
        case 0:
          this.data = this.data.concat(_.cloneDeep(this.dataBySupply));
          this.dataTotal = _.cloneDeep(this.dataBySupplyTotal);
          break;
        case 1:
          this.data = this.data.concat(_.cloneDeep(this.dataByDemand));
          this.dataTotal = _.cloneDeep(this.dataByDemandTotal);
          break;
        case 2:
          this.data = this.data.concat(_.cloneDeep(this.dataBySupplyByDomain));
          this.dataTotal = _.cloneDeep(this.dataBySupplyByDomainTotal);
          break;
      }
      // Dummy items for next pages
      for (let i: number = this.currPage; i < this.numOfPages; i++) {
        n = i + 1 < this.numOfPages ? this.itemsPerPage : this.totalAmount - (this.numOfPages - 1) * this.itemsPerPage;
        for (let j = 0; j < n; j++) {
          this.data.push({});
        }
      }
      this.isLoading = false;
      this.currSubscription = null;
      this.currTotalsSubscription = null;
    }
  }

  // On tab selected
  onTabSelected($event: any) {
    const queryParams: any = _.cloneDeep(this.queryParams);
    queryParams.tab = $event;
    this.router.navigate([], { queryParams: queryParams }).then(() => {
      return false;
    });
  }

  // On plugin partner change
  onPluginPartnerChange($event: any) {
    const queryParams: any = _.cloneDeep(this.queryParams);
    queryParams.partner = $event;
    queryParams.p = '1';
    this.filters = {};
    this.sorting = {};
    this.currPage = 1;
    this.router.navigate([], { queryParams: queryParams }).then(() => {
      return false;
    });
  }

  //filter for environment
  onEnvironmentFilterChange() {
    switch (this.filters.environment) {
      case this.dictionaryService.get('DESKTOP'):
        this.reportParams.is_desktop = 1;
        this.reportParams.is_mobile_web = 0;
        this.reportParams.is_mobile_app = 0;
        break;
      case this.dictionaryService.get('MOBILE_WEB'):
        this.reportParams.is_desktop = 0;
        this.reportParams.is_mobile_web = 1;
        this.reportParams.is_mobile_app = 0;
        break;
      case this.dictionaryService.get('MOBILE_APP'):
        this.reportParams.is_desktop = 0;
        this.reportParams.is_mobile_web = 0;
        this.reportParams.is_mobile_app = 1;
        break;
    }
  }
  // On filter change
  onFilterChange($event: any) {
    this.filters = _.cloneDeep($event);
    this.onEnvironmentFilterChange();
    this.initLoadedReportsData();
    this.parseQueryParams();
  }

  // On sort change
  onSortChange($event: any) {
    this.sorting = {
      attrName: $event.sortCell,
      sort: $event.sortDir,
    };
    this.initLoadedReportsData();
    this.parseQueryParams();
  }

  // On pagination
  onPagination($event: any) {
    const queryParams: any = _.cloneDeep(this.queryParams);
    this.initLoadedReportsData();
    this.currPage = $event;
    queryParams.p = $event.toString();
    this.router.navigate([], { queryParams: queryParams }).then(() => {
      return false;
    });
  }

  // Handle a 'start-date-changed' event from the datepicker component
  startDateChanged($event: any) {
    this.startDate = $event;
  }

  // Handle an 'end-date-changed' event from the datepicker component
  endDateChanged($event: any) {
    const queryParams: any = _.cloneDeep(this.queryParams);
    this.endDate = $event;
    if (this.endDate !== null) {
      this.initLoadedReportsData();
      this.currPage = 1;
      queryParams.sd = moment(this.startDate).format('YYYY-MM-DD').toString();
      queryParams.ed = moment(this.endDate).format('YYYY-MM-DD').toString();
      queryParams.p = '1';
      this.currPage = 1;
      this.router.navigate([], { queryParams: queryParams }).then(() => {
        return false;
      });
    }
  }
}
